// src/features/inventory/services/items.js
import { apiClient } from '../../../services/api/client';

export const itemsAPI = {
  getItems: (productGroupId = null) => {
    const params = productGroupId ? `?product_group_id=${productGroupId}` : '';
    return apiClient.get(`/api/v1/inventory/items/${params}`);
  },

  getItemById: (itemId) =>
    apiClient.get(`/api/v1/inventory/items/${itemId}`),

  createItem: ({ product_group_id, sku, name, description, uom }) =>
    apiClient.post('/api/v1/inventory/items/', { product_group_id, sku, name, description, uom }),

  updateItem: (itemId, { name, description, uom, active }) =>
    apiClient.put(`/api/v1/inventory/items/${itemId}`, { name, description, uom, active }),

  deleteItem: (itemId) =>
    apiClient.delete(`/api/v1/inventory/items/${itemId}`),

  filterItems: (body = {}) =>
    apiClient.post('/api/v1/inventory/items/filter', body),

  scanByBarcode: (barcode) =>
    apiClient.get(`/api/v1/inventory/items/scan?barcode=${encodeURIComponent(barcode)}`),
};
